import EventAddress from 'components/event/EventAddress'
import EventComment from 'components/event/EventComment'
import EventComplementaryInfos from 'components/event/EventComplementaryInfos'
import EventGeneralInfo from 'components/event/EventGeneralInfo'
import EventInfoList from 'components/event/EventInfosList'
import EventSubmitButtons from 'components/event/EventSubmitButtons'
import ORFIDropzone from 'components/files/Dropzone'
import RPGDInfo from 'components/files/RPGDInfo'
import Loader from 'components/loader/Loader'
import { CRITICAL_EVENTS_LABELS } from 'constants/eventConstants'
import moment from 'moment'
import 'moment/locale/fr'
import React, { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form'
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min'
import I18n from 'resources/i18n/I18n'
import { getEventPatrimonyData } from 'services/event.service'
import EventApi from 'services/eventApi'
import eventService from 'services/eventService'
import CONSTANTS from '../../utils/constants'
import { errorToast, successToast } from '../../utils/toast'
import Logo from '../logo/Logo'

const Report = () => {
  const user = useSelector((state) => state.userReducer.user)
  const { id } = useParams()

  const [currentEvent, setCurrentEvent] = useState({
    user,
    group: user && user.group,
    date: moment(),
    type: null,
    subtype: null,
    category: null,
    locationType: null,
    locationSubtype: null,
    recurrent: false,
    camera: false,
    address: null,
    comment: '',
    building: null,
    floor: null,
    victims: [],
    allegedPerpetrators: [],
    id,
    idPatrimony: null,
    idSector: null,
    idAgency: null,
  })

  const [showError, setShowError] = useState(false)
  const [isLoading, setIsLoading] = useState(!!id)
  const editMode = id !== undefined
  const [isFormDisabled, setIsFormDisabled] = useState(false)
  const [files, setFiles] = useState([])
  const { locations, types } = useSelector((state) => state.resourceReducer)

  const history = useHistory()

  useEffect(() => {
    fetchEvent()
  }, [])

  const fetchEvent = async () => {
    let event = { ...currentEvent }
    if (id) {
      await EventApi.getEvent(id)
        .then((response) => {
          if (!response) {
            return
          }
          eventService.normalizeEvent(response, types, locations)
          setIsFormDisabled(response.currentStatus === CONSTANTS.STATUS_LIST.REFUSED || response.currentStatus === CONSTANTS.STATUS_LIST.VALIDATED)
          setCurrentEvent(response)
          const existingFiles = response.files.filter((file) => !file.statusId)
          setFiles(existingFiles)
          event = response
        })
        .catch(() => {
          history.replace('/consulter')
        })
    }

    await fetchPatrimonyData(event)
    setIsLoading(false)
  }

  const fetchPatrimonyData = async (event) => {
    await getEventPatrimonyData(event, editMode).then(setCurrentEvent)
  }

  const editCurrentEvent = (key, value) => {
    setCurrentEvent({
      ...currentEvent,
      [key]: value,
    })
  }

  const selectDate = (date) => {
    //La librairie datepicker ne gère pas la limite sur les heures,
    //on reset la date à la date/heure du jour si l'heure dépasse l'heure actuelle
    editCurrentEvent('date', moment(moment(date).isAfter(moment()) ? moment() : moment(date)))
  }

  const handleEventType = (id) => {
    setCurrentEvent({
      ...currentEvent,
      type: types.find((x) => x.id === id),
      subtype: null,
      category: null,
    })
  }

  const handleEventSubType = (id) => {
    setCurrentEvent({
      ...currentEvent,
      subtype: currentEvent.type.subtypes.find((x) => x.id === id),
      category: null,
    })
  }

  const handleEventCategory = (id) => {
    const currentCategory = currentEvent.subtype.categories.find((x) => x.id === id)
    setCurrentEvent({
      ...currentEvent,
      category: currentCategory,
      recurrent: !currentCategory.isRecurrentFact ? null : false,
    })
  }

  const handleSiteInputChanged = (textSite) => {
    editCurrentEvent('site', textSite.target.value)
  }

  const handleBuildingInputChanged = (textBuilding) => {
    editCurrentEvent('building', textBuilding.target.value)
  }

  const handleFloorInputChanged = (textFloor) => {
    editCurrentEvent('floor', textFloor.target.value)
  }

  const handleEventPlace = (id) => {
    setCurrentEvent({
      ...currentEvent,
      locationType: locations.find((x) => x.id === id),
      locationSubtype: null,
    })
  }

  const handleEventSubPlace = (id) => {
    editCurrentEvent(
      'locationSubtype',
      currentEvent.locationType.subtypes.find((x) => x.id === id),
    )
  }

  const handleEventAddress = (address) => {
    editCurrentEvent('address', address)
  }

  const handlePatrimonyInputChanged = (idPatrimony) => {
    setCurrentEvent({
      ...currentEvent,
      idPatrimony: parseInt(idPatrimony.target.value),
      idSector: null,
      idAgency: null,
    })
  }

  const handleSectorInputChanged = (idSector) => {
    setCurrentEvent({
      ...currentEvent,
      idSector: parseInt(idSector.target.value),
      idAgency: null,
    })
  }

  const handleAgencyInputChanged = (idAgency) => {
    editCurrentEvent('idAgency', parseInt(idAgency.target.value))
  }

  const handleCommentInputChanged = (textComment) => {
    editCurrentEvent('comment', textComment.target.value)
  }

  const switchRecurrentFact = (state) => {
    editCurrentEvent('recurrent', state)
  }

  const switchCamera = (state) => {
    editCurrentEvent('camera', state)
  }

  const handleVictimChanged = (idVictim) => {
    const oldVictims = currentEvent.victims || []
    editCurrentEvent('victims', oldVictims.includes(idVictim) ? oldVictims.filter((elem) => elem !== idVictim) : [...oldVictims, idVictim])
  }

  const handleAllegedPerpetratorChanged = (idAllegedPerpetrator) => {
    editCurrentEvent('allegedPerpetrators', [idAllegedPerpetrator])
  }

  const saveEvent = (filesToAnonymize = [], event) => {
    setIsLoading(true)
    const updatedEvent = event
    if (editMode) {
      EventApi.updateEvent(updatedEvent)
        .then(async (event) => {
          await EventApi.uploadFiles(updatedEvent.id, files, null, filesToAnonymize)
          successToast(I18n.t('EditToastSuccess', { id: event.id }))
          history.push(`/evenement/${updatedEvent.id}/status`)
        })
        .catch(() => {
          errorToast(I18n.t('EditToastError', { id }))
        })
    } else {
      EventApi.createEvent(updatedEvent)
        .then(async (event) => {
          await EventApi.uploadFiles(event.id, files, null, filesToAnonymize)
          successToast(
            `${I18n.t('SaveToastSuccess', { id: event.id })}${CRITICAL_EVENTS_LABELS.includes(event.category.label) ? `\n${I18n.t('SaveToastSuccessCriticalEvent')}` : ''}`,
          )
          history.push('/accueil')
        })
        .catch(() => {
          errorToast(I18n.t('SaveToastError'))
          setIsLoading(false)
        })
        .finally(() => {
          setIsLoading(false)
          history.push('/accueil')
        })
    }
  }

  const onSubmit = (event) => {
    event.preventDefault()
    let showError = false

    const updatedEvent = {
      ...currentEvent,
      idGroup: user.group.code,
    }

    showError = !eventService.attributesIsNotNull(updatedEvent)
    setShowError(showError)
    if (showError) {
      event.preventDefault()
      return
    }

    const newFiles = files.filter((file) => !file.id)
    const imageMimeTypes = ['image/png', 'image/jpeg', 'image/jpg']
    const imagesToAnonymize = newFiles.filter((file) => imageMimeTypes.includes(file.type))

    saveEvent(imagesToAnonymize, updatedEvent)
  }

  return (
    <div className="container-fluid">
      <Logo />
      <div className="container">
        <div className="row">
          <div className="title">{`${editMode ? (isFormDisabled ? I18n.t('ReportViewTitle') : I18n.t('ReportEditTitle')) : I18n.t('ReportTitle')} ${currentEvent.id ? currentEvent.id : ''}`}</div>
        </div>
        {!isLoading ? (
          <Form onSubmit={onSubmit}>
            <EventGeneralInfo event={currentEvent} onDateChange={selectDate} disabled={isFormDisabled} />

            <EventInfoList
              list={types}
              onClick={handleEventType}
              objectSelected={currentEvent.type ? currentEvent.type.id : null}
              itemsContainerClass="row"
              disabled={isFormDisabled}
            />
            <EventInfoList
              list={currentEvent.type ? currentEvent.type.subtypes : []}
              onClick={handleEventSubType}
              objectSelected={currentEvent.subtype ? currentEvent.subtype.id : null}
              disabled={isFormDisabled}
            />
            <EventInfoList
              list={currentEvent.subtype ? currentEvent.subtype.categories : []}
              onClick={handleEventCategory}
              objectSelected={currentEvent.category ? currentEvent.category.id : null}
              customIcon={currentEvent.subtype ? currentEvent.subtype.iconName : null}
              inline
              disabled={isFormDisabled}
            />
            <EventInfoList
              list={currentEvent.category || currentEvent.locationType ? locations : []}
              onClick={handleEventPlace}
              objectSelected={currentEvent.locationType ? currentEvent.locationType.id : null}
              itemsContainerClass="row"
              disabled={isFormDisabled}
            />

            <EventInfoList
              list={currentEvent.locationType ? currentEvent.locationType.subtypes : []}
              onClick={handleEventSubPlace}
              objectSelected={currentEvent.locationSubtype ? currentEvent.locationSubtype.id : null}
              itemsContainerClass="row"
              inline
              disabled={isFormDisabled}
            />

            <EventAddress event={currentEvent} editMode={editMode} onChange={handleEventAddress} disabled={isFormDisabled} />

            <EventComplementaryInfos
              event={currentEvent}
              onAgencyChange={handleAgencyInputChanged}
              onSectorChange={handleSectorInputChanged}
              onPatrimonyChange={handlePatrimonyInputChanged}
              onBuildingChange={handleBuildingInputChanged}
              handleSiteInputChanged={handleSiteInputChanged}
              handleBuildingInputChanged={handleBuildingInputChanged}
              handleFloorInputChanged={handleFloorInputChanged}
              onRecurrentChange={switchRecurrentFact}
              onVictimChange={handleVictimChanged}
              onAllegedPerpetratorChange={handleAllegedPerpetratorChanged}
              onCameraChange={switchCamera}
              disabled={isFormDisabled}
              oldDisplay={user.group.oldDisplay}
            />

            <EventComment
              event={currentEvent}
              onChange={handleCommentInputChanged}
              showComment={user.group.enabledAttachmentAndComment}
              disabled={isFormDisabled}
            />

            {user.group.enabledAttachmentAndComment && (
              <ORFIDropzone
                className="mt-3"
                files={files}
                setFiles={setFiles}
                title={I18n.t('EventFiles')}
                subtitle={<RPGDInfo />}
                downloadFileOnServer={EventApi.downloadFile}
                deleteFileOnServer={EventApi.deleteFile}
                disabled={isFormDisabled}
              />
            )}

            <EventSubmitButtons event={currentEvent} showError={showError} disabled={isFormDisabled} />
          </Form>
        ) : (
          <Loader displayMessage />
        )}
      </div>
    </div>
  )
}

export default withRouter(Report)
